export default {
      id: "fenetre_recherche_filigrane-usage",
      viewBox: "0 0 1077 1027",
      url: "../dist/images/" + "sprite.svg#fenetre_recherche_filigrane-usage",
      toString: function () {
        return this.url;
      }
    }